import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
import axios from 'axios';
import { decode } from 'html-entities';

export class Footer extends Component  {
  state = {
    nav1: [], nav2: [], social: []
  }

  getYear() {
    return new Date().getFullYear();
  }

  componentDidMount() {
    const getMenu1 = axios.get('https://www.usa.edu/wp-json/wp-api-menus/v2/menus/2');
    const getMenu2 = axios.get('https://www.usa.edu/wp-json/wp-api-menus/v2/menus/3');
    const socialMenu = axios.get('https://www.usa.edu/wp-json/wp-api-menus/v2/menus/5');

    Promise.all([getMenu1, getMenu2, socialMenu]).then(res => {
      // console.dir(res);
      this.setState({
        nav1: res[0].data.items,
        nav2: res[1].data.items,
        social: res[2].data.items
      });
    });
  }

  render() {
    const { nav1, nav2, social } = this.state;

    return (
      <>
        <section className="footer-widgets">
          <div className="container">
            <div className="row">
              <div className="col">
                <ul id="menu-footer1">
                  {nav1.map(nav =>
                    <li key={ nav.id }> <a href={ nav.url }> { decode(nav.title) } </a> </li>
                  )}
                </ul>
              </div>

              <div className="col">
                <ul id="menu-footer2">
                  {nav2.map(nav =>
                    <li key={ nav.id }> <a href={ nav.url }> { decode(nav.title) } </a> </li>
                  )}
                </ul>
              </div>

              <div className="col">
                <embed src={process.env.PUBLIC_URL + '/global/images/logos/crest512.png'} className="logo" alt="University of St. Augustine" />

                <ul id="menu-social">
                  {social.map(nav =>
                    <li key={ nav.id } className={ 'fa fa-'+nav.object_slug }> <a href={ nav.url }> { decode(nav.title) } </a> </li>
                  )}
                </ul>
              </div>

              <div className="col">
                <p>
                  <strong>Miami, FL Campus</strong><br />
                  Douglas Entrance North Tower<br />
                  800 S. Douglas Road<br />
                  Suite 149<br />
                  Coral Gables, FL 33134
                </p>

                <p>
                  <strong>St. Augustine, FL Campus</strong><br />
                  1 University Boulevard<br />
                  St. Augustine, FL 32086
                </p>

                <p>
                  <strong>San Marcos, CA Campus</strong><br />
                  700 Windy Point Drive<br />
                  San Marcos, CA 92069
                </p>
              </div>

              <div className="col">
                <p>
                  <strong>Austin, TX Campus</strong><br />
                  5401 La Crosse Ave<br />
                  Austin, TX 78739
                </p>

                <p>
                  <strong>Dallas, TX Campus</strong><br />
                  5010 Riverside Drive, Suite 120<br />
                  Irving, TX 75039
                </p>

                <p className="numbers">
                  <strong>General:</strong> (904) 826-0084<br />
                  <strong>Media:</strong> (760) 410-5306<br />
                  <strong>Fax:</strong> (904) 826-0085<br />
                  <strong>Registrations:</strong> (800) 241-1027
                </p>
              </div>
            </div>
          </div>
        </section>

        <footer>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <p>Copyright &copy; { this.getYear() }
                  <a href="https://www.usa.edu/legal/">Legal &amp; Consumer Disclosure</a><span/>
                  <a href="https://www.usa.edu/safety-security/">Title IX / Safety &amp; Security</a><span/>
                  <a href="https://www.usa.edu/legal/privacy-policy/">Privacy Policy</a><span/>
                  <a href="https://www.usa.edu/legal/program-data/">Program Data</a><span/>
                  <a href="https://www.usa.edu/about/accreditation/">Accreditation</a><span/>
                  <a href="https://www.usa.edu/about/contact-us/">Contact</a>
                </p>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;